import { render } from "./GalleryRooms.vue?vue&type=template&id=50bb2de4&scoped=true"
import script from "./GalleryRooms.vue?vue&type=script&lang=js"
export * from "./GalleryRooms.vue?vue&type=script&lang=js"

import "./GalleryRooms.vue?vue&type=style&index=0&id=50bb2de4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bb2de4"]])

export default __exports__